import React from 'react';
import { useDispatch } from 'react-redux';
import { FixedSizeList as List } from 'react-window';
import { isNil } from 'ramda';
import { useRTL } from '@prezi/common-components';
import Email from '../../../models/Email';
import { actions } from '../../../store/actions/actions';
import Collaborator from './Collaborator';
import CollaboratorPermission from '../../../utils/permissions';
const collaboratorRowHeight = 45;
const collaboratorListMaxHeight = collaboratorRowHeight * 4;
export default (({
  currentUserData,
  collaborators
}) => {
  const {
    direction
  } = useRTL();
  const dispatch = useDispatch();
  const collaboratorList = collaborators.asList().map(collaborator => {
    const {
      is_owner: isOwner,
      pending_invite: isPendingInvite,
      email,
      first_name: firstName,
      last_name: lastName,
      is_current_user: isCurrentUser
    } = collaborator;
    const maybeCollaboratorPermission = CollaboratorPermission.fromPermissionType(collaborator);
    if (isNil(maybeCollaboratorPermission)) {
      return null;
    } else {
      return React.createElement(Collaborator, {
        key: `collaborator-${email.split('@')[0]}`,
        isOwner: isOwner,
        isPendingInvite: isPendingInvite,
        caption: email,
        permission: maybeCollaboratorPermission,
        avatarProps: {
          firstName,
          lastName,
          email,
          isCurrentUser
        },
        onChange: permission => permission && dispatch(actions.updateCollaborator(Email.unsafeFromString(email), permission)),
        onRemove: () => dispatch(actions.removeCollaborator(Email.unsafeFromString(email))),
        currentUserData: {
          isOwner: currentUserData.isOwner,
          updateCollaboratorsPermissions: currentUserData.individualUpdateCollaboratorsPermissions
        }
      });
    }
  });
  const Row = ({
    data,
    index,
    style
  }) => React.createElement("div", {
    className: `collaborator-row-${index}`,
    style: {
      ...style,
      display: 'flex',
      alignItems: 'center',
      paddingInlineStart: 8
    }
  }, data[index]);
  const itemCount = collaborators.asList().length;
  const collaboratorListHeight = itemCount < 4 ? collaboratorRowHeight * itemCount : collaboratorListMaxHeight;
  return React.createElement(List, {
    direction: direction,
    width: "100%",
    height: collaboratorListHeight,
    itemCount: itemCount,
    itemSize: collaboratorRowHeight,
    itemData: collaboratorList,
    style: {
      overflow: 'hidden auto'
    }
  }, Row);
});